import React, { useState } from "react";
import "./academic_calendar.css";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const AcademicCalendar = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const syllabusData = [
    {
      title: "B.Tech Marine Engineering",
      tables: [
        [
          ["Plan for semester: Even semester – Sem II, IV, VI, VIII"],
          ["Event", "Date"],
          ["Date of start of semester", "19th Jan 2026"],
          ["Mid-term exam date", "16th – 24th March 2026"],
          ["Date of end of semester", "15th May 2026"],
          ["Practical Exam dates", "20th - 28th May 2026"],
          [
            "Preparatory leave for cadets",
            " 16th May– 02th Jun 2026",
          ],
          ["End semester exam dates", "02th -24th June 2026"],
          ["End semester Vacation", "25th June-19th July 2026"],
          ["Date of results", "Within 20 days of last exam"],
          ["Date of start of next semester", "20th July 2026"],
        ],
      ],
    },
    {
      title: "B.Sc Nautical Science",
      tables: [
        [

            ["Plan for semester: Even semester – Sem II, IV "],
            ["Event", "Date"],
            ["Date of start of semester", "19th Jan 2026"],
            ["Mid-term exam date", "24th – 27th March 2026"],
            ["Date of end of semester", "15th May 2026"],
            ["Practical Exam dates", "19th -26th May 2026"],
            ["Preparatory leave for cadets", "16th May– 09th Jun 2026"],
            ["End semester exam dates", "04th -15th June 2026"],
            ["End semester Vacation", "16th June-19th July 2026"],
            ["Date of results", "Within 20 days of last exam"],
            ["Date of start of next semester", "20th July 2026"],
    
        ],
        [
          
            ["Plan for semester: Even semester – Sem VI"],
            ["Event", "Date"],
            ["Date of start of semester", "27th Jan 2026"],
            ["Mid-term exam date", "24th – 27th March 2026"],
            ["Date of end of semester", "22nd May 2026"],
            ["Practical Exam dates", "19th -26th May 2026"],
            ["Preparatory leave for cadets", "23rd May– 09th Jun 2026"],
            ["End semester exam dates", "09th -19th June 2026"],
            ["End semester Vacation", "20th July onwards"],
            ["Date of results", "Within 20 days of last exam"],
            ["Date of start of next semester", "N/A"],
          
        ],
      ],
    },
    {
      title: "Diploma in Nautical Science",
      tables: [
        [
          ["Plan for semester: Even semester – Sem II"],
          ["Event", "Date"],
          ["Date of start of semester", "27th Jan 2026"],
          ["Mid-term exam date", "23rd March – 30th March 2026 "],
          [
            "Mid-term Practical exams",
            "During normal Time table hours ",
          ],
          ["Date of end of semester", "22nd May 2026"],
          ["Practical Exam dates", "25th  May – 27th May 2026"],
          ["Preparatory leave for cadets", "23rd May – 01st June 2026"],
          ["End semester exam dates", "01st June – 12th June 2026"],
          ["Date of results", "Within 20 days of last exam"],
        ],
      ],
    },
  ];

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div>
      <h1 className="title">Academic Calendar</h1>
      <hr />
      <h4 className="innerpage-heading" id="syllabus-title">
        Proposed Academic Plan of Even Semester 2026-27
      </h4>
      <div className="page-content-container">
        {syllabusData.map((course, courseIndex) => (
          <div key={courseIndex} className="accordion-item">
            {/* Accordion Header */}
            <Accordion
              title={course.title}
              isActive={activeAccordion === courseIndex}
              onClick={() => toggleAccordion(courseIndex)}
            />

            {/* Accordion Content */}
            {activeAccordion === courseIndex && (
              <div className="accordion-content">
                <div className="syllabus-tables-grid">
                  {course.tables.map((table, tableIndex) => (
                    <div key={tableIndex} className="table-responsive">
                      <table className="page-content-table" id="syllabus-table">
                        <tbody>
                          {table.map((row, rowIndex) => {
                            // Section title row
                            if (row.length === 1) {
                              const nextHeader = table.find(
                                (r) => r.length > 1,
                              );
                              const colCount = nextHeader
                                ? nextHeader.length
                                : 1;

                              return (
                                <tr key={rowIndex}>
                                  <th
                                    colSpan={colCount}
                                    style={{ textAlign: "center" }}
                                  >
                                    {row[0]}
                                  </th>
                                </tr>
                              );
                            }

                            // Header row
                            if (rowIndex === 1) {
                              return (
                                <tr key={rowIndex} className="table-subheading">
                                  {row.map((cell, cellIndex) => (
                                    <th key={cellIndex}>{cell}</th>
                                  ))}
                                </tr>
                              );
                            }

                            // Data row
                            return (
                              <tr key={rowIndex}>
                                {row.map((cell, cellIndex) => (
                                  <td key={cellIndex}>{cell}</td>
                                ))}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <p className="page-content-note">
        <b>Note:</b> This is a tentative plan of activities just for
        information, which might change as per the Govt. and DGS guidelines
        issued from time to time.
      </p>
    </div>
  );
};

export default AcademicCalendar;
